{
    "common": {
        "skipLink": {
            "skipTo": "Skip to",
            "labels": {
                "header": "Header",
                "main": "Main content",
                "footer": "Footer",
                "productFacets": "Product filters",
                "productList": "Product list"
            }
        },
        "common": {
            "cancel": "Cancel",
            "back": "Back",
            "reset": "Reset",
            "search": "Search",
            "remove": "Remove",
            "home": "Home",
            "contacts": {
                "openingHours": "(Mon-Fri 8:00 - 15:30)",
                "sikob2bspacz": {
                    "phone": "+420 222 300 666",
                    "email": "velkoobchod@siko.cz",
                    "helplineAvailibility": "(Mo-Fr 8:00 - 15-30)"
                },
                "sikob2bspask": {
                    "phone": "+421 222 300 666",
                    "email": "velkoobchod@siko.sk",
                    "helplineAvailibility": "(Mo-Fr 8:00 - 15-30)"
                },
                "sikob2bspaeu": {
                    "phone": "+420 222 300 666",
                    "email": "info@b2b.siko.eu",
                    "helplineAvailibility": "(Mo-Fr 8:00 - 15-30)"
                }
            }
        },
        "formErrors": {
            "labeled": {
              "email": "Invalid email format",
              "sikoWrongValueDiscount": "Discount value out of range.",
                "sikoCompanyVatIDExists": "The company VAT ID has already been registered.",
                "sikoCompanyVatIDError": "Please enter a valid VAT number.",
                "sikoOtherCountry" : "We apologize, but the registration of customers from countries outside the EU member states is currently not supported. If you are interested in cooperation, please do not hesitate to contact us.",
                "required": "Required",
                "sikoInvalidTotalPrice": "The order could not be send due to low value.",
                "sikoTermsAndConditions": "Agreement to the terms and conditions is mandatory.",
                "sikoPreferredPickupDateWeekendDisable": "Weekend pickup is not possible",
                "sikoPreferredPickupDateHigherThanMax": "Enter date max. 2 months in the future.",
                "sikoPreferredPickupDateLowerThanToday": "The entered date must not be lower than the current date.",
                "sikoRequiredDate": "Incorrect or missing date.",
                "sikoCheckoutNote": "You have exceeded the 255 character limit",
                "sikoPoNumber": "You have exceeded the 35 character limit",
                "pattern": "Enter the correct format",
                "maxlength": "The data entered exceeds the maximum length",
                "cxInvalidPassword": " Password does not meet minimum requirements. (At least 8 characters, including 1 letter and 1 number)",
                "cxInvalidOldPassword": "Please enter your current password",
                "cxInvalidEmail": "Field has not a valid email format.",
                "sikoPhoneFormat": "Enter phone number in correct format",
                "sikoZipCode": "The entered ZIP code is not valid.",
                "sikoVat": "Enter company VAT ID in correct format",
                "sikoTaxId": "Enter company TAX ID in correct format",
                "sikoPostCode": "Enter postal code in correct format",
                "sikoPassword": "Incorrect password format (Use at least 8 characters, including 1 letter and 1 number)",
                "sikoFullNameLength": "Items (First Name, Surname) exceed the maximum length (40)",
                "sikoCompanyName": "The data entered exceeds the maximum length (40)",
                "sikoPin": "Enter 6 characters long PIN code that had been delivered to you via chosen method.",
                "matDatepickerParse": "Enter the valid date in the format dd.mm.yyyy",
                "matDatepickerFilter": "Enter a valid date in DD.MM.YYYY format",
                "matDatepickerMin": "Enter a valid date range.",
                "sikoInvalidCode": "The entered coupon code is not valid.",
                "sikoPositiveNumber": "Enter a positive number",
                "emailNotAllowed": "Invalid username",
                "cxPasswordsMustMatch": "Passwords must match",
                "cxEmailsMustMatch": "Email addresses must match",
                "file": {
                    "notParsable": "File cannot be loaded",
                    "tooManyEntries": "Number of items is greater than {{ maxEntries }}",
                    "empty": "File must not be empty",
                    "invalidExtension": "Unsupported file format",
                    "tooLarge": "File size must not exceed {{ maxSize }} MB"
                }
            }
        },
        "customLoginPage": {
          "badRequest": {
            "bad_credentials": "<strong>Invalid login credentials. Please sign in again.</strong><br><br>If you are sure that you are entering the correct password, it may need to be reset due to a system update using the <strong>“Forgot Password”</strong> option.",
            "account_disabled": "User is disabled. Please contact administration.",
            "missing_id": "Login failed. Please wait for the confirmation e-mail.",
            "missing_store": "Login failed. Please contact the customer center for a solution.",
            "wrong_basestore": "Login failed. Please check the entered URL according to your registration.",
            "unknown_error": "An unknown error occurred. Please try again later."
          }
        },
        "httpHandlers": {
            "SikoCartPaymentMinValueError": "Too low order value. Please select a different payment method.",
            "maintenanceError": "This service is temporarily unavailable due to maintenance.",
            "loginRequire": "Please login before claiming the coupon.",
            "userUidNotFound": "Unable to find user with UID: {{ uid }}",
            "cartNotFound": "Cart not found. Please refresh the page.",
            "badRequest": {
                "bad_credentials": "Incorrect login or password. Please try again.",
                "password_expired": "{{ errorMessage }}. Please change your password.",
                "user_is_disabled": "User is disabled. Please contact the administration."
            },
            "sessionExpired": "Your session has expired. Please login again.",
            "authenticationErrors": {
                "badRequest": "Login failed. Please try again.",
                "wrongUserModel": "Only Employee may login into ASM.",
                "asmAgentMissingRoles": "The ASM agent lacks the necessary permissions"
            },
            "timeout": "Unable to display content for the specified period. Try narrowing down the search period.",
            "validationErrors": {
                "missing": {
                    "deliveryAddressStreetNumber": "Invalid delivery street number",
                    "deliveryAddress": {
                        "countryIso": "Invalid company country Iso",
                        "postcode": "Invalid company postal code"
                    },
                    "email": "Invalid email",
                    "phonePrefix": "Invalid phone number prefix"
                },
                "invalid": {
                    "password": "The entered password is not valid.",
                    "companyId": "Invalid company ID",
                    "companyVatId": "Invalid company VAT ID",
                    "legalFormType": "Invalid legal form type",
                    "companyName": "Invalid company name",
                    "companyAddressCity": "Invalid company city",
                    "companyAddressPostalCode": "Invalid company postal code",
                    "companyAddressStreet": "Invalid company street name",
                    "companyAddressStreetNumber": "Invalid company street number",
                    "companyAddressCountryIso": "Invalid company country Iso",
                    "deliveryAddressStreetNumber": "Invalid delivery street number",
                    "phonePrefix": "Invalid phone number prefix",
                    "email": "Invalid e-mail",
                    "phone": "Invalid phone format",
                    "company": {
                        "postalCode": "Invalid company postal code",
                        "vatId": "Your VAT number could not be verified. If you need help, please contact our technical support team."
                    },
                    "contactPerson": {
                        "firstName": "Invalid first name",
                        "lastName": "Invalid last name",
                        "email": "Invalid e-mail",
                        "pwd": "Invalid password",
                        "checkPwd": "Invalid repeat password",
                        "consentForm": {
                            "phone": "Invalid phone number"
                        },
                        "phone": "Invalid phone number"
                    },
                    "deliveryAddress": {
                        "townCity": "Invalid delivery city",
                        "line1": "Invalid delivery street name",
                        "postcode": "Invalid delivery postal code"
                    },
                    "couponAssignResult": {
                        "ASSIGNED": "You have already claimed this customer coupon.",
                        "INEXISTENCE": "This customer coupon does not exist.",
                        "INCORRECTPROMOGROUP": "This customer coupon is invalid."
                    }
                }
            },
            "sikoTicketMaxUploadSize": "The sum of the file sizes can be a maximum of {{ maxSize }} MB",
            "sikoTicketMaxCountOfFiles": "Max count of images is 10",
            "notFound": {
                "product": "Product not found",
                "category": "Category not found"
            },
            "cart": {
                "noRestoredEntries": "No cart entries were restored.",
                "reloadCartRequired": "There has been a change in the cart. Please refresh the page.",
                "changePartialDeliveryFailed": "Partial delivery setup was not successful"
            },
            "product": {
                "reviewPostForbidden": "You can only review products you have purchased."
            },
            "invalidCodeProvided": "An invalid code was entered.",
            "badRequestOldPasswordIncorrect": "Old password is incorrect.",
            "forbidden": "You do not have permission to perform this action. If you believe this is an error, please contact your administrator.",
            "serverError": "A server error has occurred. Please try again later.",
            "badGateway": "A server error has occurred. Please try again later.",
            "gatewayTimeout": "The server did not respond, please try again later."
        },
        "navigation": {
            "categoryNavLabel": "Category menu",
            "footerNavLabel": "Footer links",
            "goTo": "Go to {{location}}",
            "navigateTo": "Navigate to {{nav}}",
            "scrollToTop": "Scroll back to the top of the page",
            "linkItemInList": "{{title}}. {{position}} of {{listLength}}",
            "menuButonTitle": "{{title}} Menu"
        },
        "miniCart": {
            "item": "{{count}} item currently in your cart",
            "item_other": "{{count}} items currently in your cart",
            "total": "{{total}}",
            "count": "{{count}}"
        },
        "pageMetaResolver": {
            "category": {
                "title": "{{count}} result for {{query}}",
                "title_other": "{{count}} results for {{query}}"
            },
            "checkout": {
                "title": "Checkout"
            },
            "search": {
                "title": "{{count}} result for \"{{query}}\"",
                "title_other": "{{count}} results for \"{{query}}\"",
                "findProductTitle": "{{count}} result for coupon \"{{coupon}}\"",
                "findProductTitle_other": "{{count}} results for coupon \"{{coupon}}\"",
                "default_title": "All products"
            },
            "product": {
                "description": "{{description}}",
                "heading": "{{heading}}",
                "title": "{{title}}"
            }
        }
    },
    "organization": {
        "orgUnit": {
            "header": "Units",
            "uid": "Unit ID",
            "name": "Unit name",
            "assignedPos": "Sales office",
            "assignedWorker": "SIKO Account Manager",
            "state": "State"
        },
        "orgUser": {
            "active": "Status",
            "name": "User",
            "unit": "Business unit",
            "sort": {
                "byName": "Names",
                "byUnit": "Units"
            }
        },
        "organization": {
            "enabled": "Active",
            "disabled": "Disabled",
            "httpHandlers": {
                "conflict": {
                    "user": "User with email {{code}} already exists."
                }
            },
            "notification": {
                "noSufficientPermissions": "You do not have sufficient permissions to access this page"
            }
        }
    },
    "checkout": {
        "checkout": {
            "invalid": {
                "accountType": "You need to have customer role to make a purchase."
            }
        }
    },
    "configuration": {
        "configuration": {
            "configure": "Configure"
        }
    },
    "product": {
        "itemCounter": {
            "removeOne": "Remove one",
            "addOneMore": "Add one more",
            "quantity": "Quantity"
        },
        "product": {
            "productPageTitle": "{{title}} | SIKO B2B"
        },
        "addToCart": {
            "addToCart": "Add to basket"
        },
        "productReview": {
            "thankYouForReview": "Thank you for your review."
        },
        "TabPanelContainer": {
            "tabs": {
                "ProductDetailsTabComponent": "Product detail",
                "ProductReviewsTabComponent": "Reviews",
                "ProductDocumentsTabComponent": "Documents"
            }
        }
    },
    "myAccount": {
        "updateProfileForm": {
            "customerId": "Email address",
            "firstName": {
                "label": "First name"
            },
            "lastName": {
                "label": "Last name"
            },
            "profileUpdateSuccess": "Personal details have been successfully updated"
        },
        "myCoupons": {
            "claimCustomerCoupon": "You have successfully claimed this coupon."
        }
    },
    "checkoutB2B": {
        "checkoutB2B": {
            "checkoutPageTitle": "Checkout | SIKO B2B",
            "invalid": {
                "accountType": "You need to have customer role to make a purchase."
            }
        }
    },
    "importExport": {
        "exportEntries": {
            "columnNames": {
                "name": "Name",
                "code": "Code",
                "package": "Measure unit",
                "amount": "Quantity",
                "retailPrice": "Retail price",
                "discount": "SIKO price discount",
                "customerPrice": "Wholesale price without VAT",
                "totalPrice": "Total price with VAT",
                "unit": "Unit",
                "url": "Link",
                "quantity": "Quantity"
            }
        }
    },
    "productListingPage": {
        "productListingPage": {
            "plpPageTitle": "{{title}} | SIKO B2B",
            "searchResultPageTitle": "Search {{query}} | SIKO B2B"
        }
    },
    "address": {
        "addressForm": {
            "title": "Title",
            "defaultTitle": "Title",
            "companyName": "Company name (optional)",
            "firstName": {
                "label": "First name",
                "placeholder": "First name"
            },
            "lastName": {
                "label": "Last name",
                "placeholder": "Last name"
            },
            "address1": "Street",
            "address2": "Street number",
            "country": "Country",
            "city": {
                "label": "City",
                "placeholder": "City"
            },
            "state": "District",
            "zipCode": {
                "label": "ZIP Code",
                "placeholder": "ZIP Code"
            },
            "phoneNumber": {
                "label": "Phone number",
                "placeholder": "(555) 555 - 0123"
            },
            "email": {
                "label": "E-mail"
            }
        }
    },
    "cart": {
        "cartItems" : {
          "itemRemoved": "The selected item has been removed. The total amount of the cart has been updated."
        },
        "validation": {
            "cartEntriesChangeDuringCheckout": "During checkout we found problems with your entries. Please review your cart.",
            "cartEntryRemoved": "{{name}} was removed from the cart due to being unavailable.",
            "productOutOfStock": "{{name}} has been removed from the cart due to insufficient stock.",
            "lowStock": "Quantity has reduced to {{quantity}} due to insufficient stock.",
            "nonValidTotalPrice": "Unable to continue due to low cart value.",
            "couponNotValid": "The coupon is not valid, so it has been removed."
        },
        "voucher": {
            "applyVoucherSuccess": "Coupon {{voucherCode}} has been applied.",
            "removeVoucherSuccess": "Coupon {{voucherCode}} has been removed."
        }
    },
    "savedCartList": {
        "savedCartList" : {
            "swapCartNoActiveCart": "Cart \"{{cartName}}\" has been restored successfully.",
            "swapCartWithActiveCart": "Cart \"{{cartName}}\" has been restored successfully. Your previous items have been saved to cart {{previousCartName}}."
        }
    },
    "savedCartCartPage": {
        "savedCartCartPage": {
            "messages": {
                "cartSaved": "The items in your cart have been successfully saved for later in the \"{{cartName}}\" cart"
            }
        }
    },
    "user": {
        "authMessages": {
            "signedOutSuccessfully": "You have been successfully logged out.",
            "unrecoverableError": "Unable to initiate sign-in, please contact your administrator."
       }
    },
    "siko": {
        "siko": {
            "rateLimit": "We have detected an increased number of requests from your device. Access to the SIKO website has therefore been temporarily limited.\nPlease close the page, wait a moment, and then try again.",
            "addedToCartWithReducedAmount": "Quantity per item: {{ product }} was reduced from {{ quantity }} {{ unit }} to {{ addedQuantity }} {{ unit }} due to insufficient stock in stock",
            "totalPriceWithoutTax": "Total without VAT",
            "addToCartAll": "Add all to cart",
            "reloadPage": "Reload the page",
            "freeGift": "Free gift",
            "datatableOfQuantityRecords_one": "from {{count}} record",
            "datatableOfQuantityRecords_other": "from {{count}} records",
            "correctErrorsBelow": "Please correct the errors below.",
            "buy": "Buy",
            "viewMode": "Layout:",
            "bonusGroup": "Wholesale group",
            "importSavedCart": "Import saved cart",
            "yes": "Yes",
            "cancel": "Cancel",
            "count": "Quantity",
            "contactSiko": "Contact SIKO",
            "contactHeading": "Contact",
            "storeDetail": "Store detail",
            "backToStore": "Back to the store",
            "deleteCart": "Delete cart",
            "continueInShopping": "Continue in shopping",
            "delivery": "Delivery",
            "allowPartialDelivery": "Partial delivery",
            "total": "Total",
            "sikoPrice": "SIKO price",
            "superPrice": "Super Price",
            "documents": "Attachments",
            "withVat": "with VAT",
            "withoutVat": "without VAT",
            "packaging": "Packaging",
            "pricePerPackage": "Price per Package",
            "yourPrice": "Your price",
            "quantity": "Quantity",
            "priceForEach": "Price for each",
            "price": "Price",
            "categories": "Categories",
            "priceMO": "Retail price",
            "item": "Item",
            "changePassword": "Change password",
            "personalData": "Personal data",
            "saveDate": "Save",
            "removeOrderEntry": "Remove",
            "companyId": "Company ID",
            "vatId": "VAT ID",
            "vatNumber": "VAT number",
            "businessVatId": "Business ID",
            "displayDocuments": "Show documents",
            "order": "Order",
            "sapOrder": "Order",
            "orderPoNumber": "Personal order label",
            "datePlaced": "Date Placed",
            "orderPlacedBy": "Order placed by",
            "orderStatus": "Order Status",
            "totalPrice": "Total",
            "shippingDetails": "Shipping information",
            "shippingMethod": "Shipping Method",
            "billingDetails": "Billing information",
            "paymentType": "Payment Type",
            "repeatPayment": "Repeat payment",
            "reorder": "Reorder",
            "sapCodeTitle": "Order Number",
            "sapQuoteTitle": "Quote Number",
            "select": "Select",
            "confirm": "Confirm",
            "discount": "Discount",
            "more": "More",
            "shipping": "Shipping",
            "savedAmountMessage": "You saved {{savedAmount}} on your order",
            "orderNote": "Order note",
            "searchBoxPlaceHolder": "Try to write e.g. bath, sink… (or enter a search term…)",
            "searchProduct": "Search product",
            "myAccountTitle": "My account",
            "technicalDraw": "Technical draw",
            "drawing": "Drawing",
            "video": "Video",
            "downloadPdf": "Download (.PDF)",
            "purchasableJustInOtherShopMessage": "This product can only be purchased at some of the stores",
            "pickUpInMyStore": "Pickup in store",
            "deliverToAddress": "Deliver to address",
            "pickUpAtAnotherStore": "Pick up at another store",
            "storeDisponibility": "Availability in store",
            "eShopDisponibility": "Availability from e-shop",
            "inStock": "In Stock",
            "except": "Except:",
            "saleEnded": "The sale has ended",
            "inCentralStock": "In stock at the central",
            "outOfStock": "Out of stock",
            "awaiting": "Waiting",
            "onOrder": "On order",
            "days": "days",
            "onPredefinedPointOfService": "At my store",
            "ourProductCode": "Our product code",
            "ean": "EAN",
            "countOfProducts_one": "{{count}} product",
            "countOfProducts_other": "{{count}} products",
            "emptyFilters": "No filters were found.",
            "mark": "mark",
            "originCountry": "Country of origin",
            "statisticalNumber": "Statistical number",
            "category": "Category",
            "topSellingProducts": "Top selling",
            "displayNext": "Display next",
            "series": "Series",
            "brands": "Brands",
            "product": "Product",
            "products": "Products",
            "concept": "Concept",
            "showMore": "Show more",
            "hide": "Hide",
            "moreAboutProduct": "More about product",
            "showDetails": "Show detail",
            "showAllResults": "Show all results",
            "fullOffer": "Full offer",
            "stores": "Stores",
            "continueToRead": "Continue reading",
            "filtering": "Filter",
            "sorting": "Sort",
            "sortingBy": "Sorting by:",
            "proformInvoice": "Proform invoice",
            "orderConfirmationMessage": "Order confirmation",
            "selectNoItemsFound": "No items found",
            "notAllowedAction": "Unable to perform this action",
            "delete": "Delete",
            "charactersLeft": "Character left : {{count}}",
            "removedCart": "Your cart has been deleted successfully",
            "or": "or",
            "goToCart": "Go to cart",
            "openDetail": "Open detail",
            "searchStorePlaceHolder": "Enter a city or zip code",
            "updatePrice": "Update price",
            "plpLoadMore": "Load more",
            "seenQuantityOfTotal_one": "You have seen {{quantity}} of {{count}} product.",
            "seenQuantityOfTotal_other": "You have seen {{quantity}} of {{count}} products.",
            "updateProfileDetails": "Update profile",
            "contentPageTitle": "{{title}} | SIKO B2B",
            "selectCsvFile": "Select .CSV file",
            "importOtherFile": "Select another file",
            "weight": "Weight",
            "free": "Free",
            "onRequest": "On request",
            "deleteItem": "Delete item",
            "checkoutPageTitle": "Payment | SIKO B2B",
            "pickUpInStore": "Pick up in store",
            "deliveryToAddress": "Shipping to address",
            "pickupPoints": "Pickup points",
            "addressOfShipment": "SIKO shipment to the address",
            "cart": "Cart",
            "totalVAT": "Total VAT",
            "vatExcludedEu": "(VAT excluded)",
            "subtotal": "Subtotal",
            "orderDiscounts": "Order Discounts",
            "orderTotal": "Order Total",
            "VATexcluded": "without VAT",
            "exportCartInfo": "The final price will be recalculated in the last checkout step",
            "notAddedDeliveryRestrictionMessage": "Sorry, we do not allow shipping to address and pickup in a store within the same order.",
            "phoneNumberPrefix": "Phone number prefix",
            "countryCode": "Country code",
            "backToShop": "Back to the e-shop",
            "insufficientAmount": "Not sufficient amount in store {{pointOfService}}",
            "importOrderEntries": "Import cart",
            "outOf": "of",
            "predefinedPOS": " (preferred)",
            "from": "od",
            "pickupPoint": "Pickup point",
            "unit": {
                "items": "pcs",
                "items_one": "pc",
                "items_other": "pcs"
            },
            "footer": {
                "numberOfStoresInSK": "in SK",
                "numberOfStoresInCZ": "in CZ",
                "needHelp": "Need help?",
                "helpAssistanceMessage": "The assigned employee will be happy to help you."
            },
            "myAccountSideMenu": {
                "purchases": "Purchases",
                "account": "Account"
            },
            "pickupInOtherStoreDialog": {
                "productAvailabilityByStore": "Product Availability by Store Location",
                "searchPlaceholder": "Enter a Town/Coty or Zip Code:"
            },
            "showcaseDialog": {
                "productShowcaseInStore": "List of stores where the product is on display"
            },
            "userAccount": {
                "miniLogin": {
                    "signInRegister": "Log In",
                    "signIn": "Log In",
                    "myAccount": "My account"
                }
            },
            "address": {
                "id": "ID",
                "taxId": "Tax ID",
                "vatIdCz": "VAT ID",
                "vatIdOthers": "VAT ID",
                "addressForm": {
                    "companyName": "Company name (optional)",
                    "createAndSet": "Select and choose address",
                    "email": {
                        "label": "E-mail"
                    }
                }
            },
            "productLabel": {
                "new": "New",
                "sale": "Sale",
                "hit": "Hit"
            },
            "openingHours": {
                "title": "Opening Hours",
                "currentlyOpen": "Currently open",
                "currentlyClosed": "Currently closed",
                "closed": "Closed",
                "forDay": "Opening hours for",
                "openingHoursChanged": "Opening hours changed"
            },
            "otherStoreDialog": {
                "onOrder": "Sorry. Unfortunately, we do not have the goods in stock at the store, but you can order them.",
                "inStock": "We have in stock. Do you want to pick up the goods at a selected store?",
                "orderInStore": "Order in store",
                "addToCart": "Add to cart",
                "searchHeading": "Store search"
            },
            "sellUnits": {
                "MBL": "Small package",
                "VBL": "Large pack",
                "DBL": "Supplier packaging"
            },
            "pdpProductDialog": {
                "title": "Product information"
            },
            "payment": {
                "errorGeneral": "Error occurred while processing request",
                "error": "An error occured while processing payment",
                "pgnr": "Your payment was not processed due to a payment gateway unavailable",
                "sapOrderNotFound": "This order cannot be paid"
            },
            "invoiceType": {
                "REGULAR": "Invoice",
                "DEPOSIT": "Deposit Invoice",
                "CREDIT": "Credit note",
                "CREDIT_PRICE": "Price credit note",
                "DEBIT_PRICE": "Price debit note",
                "CREDIT_BONUS": "Bonus credit note",
                "CANCELLATION": "Cancellation invoice",
                "DEPOSIT_CANCELLATION": "Cancellation deposit invoice",
                "CREDIT_CANCELLATION": "Cancellation credit note"
            },
            "deliveryNoteType": {
                "REGULAR": "Regular delivery note",
                "RETURN": "Return delivery note"
            },
            "orderConfirmation": {
                "thankYouMessage": "Thank you for your order",
                "processingOrderMessage": "Your order is being processed.",
                "confirmOrderMessage": "You will receive a confirmation with the order number as soon as possible.",
                "proformaMessage": "You have selected a payment: {{ paymentType }}. You can find the proforma invoice in the the order detail after its confirmation.",
                "pendingMessage": "Your payment is being processed.",
                "paidMessage": "Your order has been successfully paid.",
                "cancelledMessage": "Your payment was cancelled.",
                "emailMessage": "A copy of your order details will be sent to",
                "repeatPayment": "Repeat payment",
                "errorMessage": "Your payment ended in error.",
                "bonusProgramPoints": "Your {{count}} bonus points are on their way to you!",
                "bonusProgramInfo": "Once you receive your goods, these points will be credited to your account. You can use the points you earn to get a discount on selected items."
            },
            "ticket": {
                "ticket": "Ticket",
                "ticketHistoryPageTitle": "Ticket history",
                "allDetails": "All details",
                "product": "Product",
                "addData": "Submit",
                "order": "Order",
                "creationDate": "Creation Date",
                "deliveryDate": "Delivery Date",
                "document": "Document",
                "addedPhotos": "Attached photos",
                "yourNote": "Your note",
                "comments": "Comments",
                "sendTicket": "Move to processing",
                "notFound": "Ticket not found",
                "creationError": "Ticket could not be created",
                "status": {
                    "label": "State",
                    "customeraction": "Customer action",
                    "open": "New",
                    "inprocess": "In process",
                    "conflict": "Conflict",
                    "resolved": "Resolved",
                    "rejected": "Rejected"
                },
                "reason": {
                    "label": "Reason",
                    "complaint": "Complaint/Claim",
                    "discrepancy": "Discrepancy",
                    "damaged": "Damaged",
                    "incorrect_amount": "Incorrect amount",
                    "not_delivered": "Not delivered",
                    "incorrect_product": "Incorrect product",
                    "incorrect_color_dimension": "Incorrect color/dimension",
                    "other": "Other"
                }
            },
            "facet": {
                "activeFilters_one": "{{count}} active",
                "activeFilters_other": "{{count}} active",
                "shownProducts_one": "{{count}} product displayed",
                "shownProducts_other": "{{count}} products displayed",
                "label": "Filter",
                "notFound": "Hmm... Nothing was found.",
                "cancelFacets": "Cancel all filters",
                "cancelFacetsShort": "Cancel all",
                "showMoreFacets": "Next",
                "showResults": "Show result",
                "updateFilters": "Update filters",
                "typeSearchString": "Enter a search term",
                "activeList": "Active filters:"
            },
            "disponibility": {
                "inStock": "In stock {{amount}} {{unit}}",
                "upcoming": "On the way",
                "upcomingWithDelivery": "Awaiting {{date}}",
                "onOrder": "Order only",
                "onOrderWithTime_one": "Estimated delivery in {{count}} day",
                "onOrderWithTime_other": "Estimated delivery in {{count}} days",
                "outOfStock": "Out of stock"
            }
        }
    },
    "userAccount": {
        "loginForm": {
            "forgotPassword": "Forgot your password?",
            "signIn": "I want to sign in",
            "register": "Register",
            "dontHaveAccount": "Don't have an account?",
            "emailAddress": {
                "label": "Email",
                "placeholder": "Email"
            },
            "password": {
                "label": "Password",
                "placeholder": "Password"
            },
            "wrongEmailFormat": "This is not a valid email format.",
            "logIn": "Log in"
        },
        "miniLogin": {
            "userGreeting": "Hello, {{name}}",
            "signInRegister": "Sign in / Register",
            "signIn": "Sign in",
            "myAccount": "My account"
        }
    }
}
